import './styles/settingsDialog.css';
import { useGameStore } from '../../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import { useTheme } from '../../../theme/Theme';
import Dialog from '../../subcomponents/Dialog';
import Toggle from '../../subcomponents/Toggle';
import TextField from '../../subcomponents/TextField';

type SettingsDialogProps = {
  open: boolean;
  onClose: () => void;
};

function SettingsDialog(props: SettingsDialogProps) {
  const { open, onClose } = props;

  const { setSoundEnabled, soundEnabled, username, setUsername } = useGameStore(
    useShallow((state) => ({
      setSoundEnabled: state.setSoundEnabled,
      soundEnabled: state.soundEnabled,
      username: state.username,
      setUsername: state.setUsername,
    }))
  );

  const { toggleTheme, theme } = useTheme();
  const toggleSound = () => {
    setSoundEnabled(!soundEnabled);
  };

  return (
    <Dialog open={open} onClose={onClose} title="SETTINGS">
      <div className="settings-container">
        <div className="settings-row">
          <span className="settings-text">DARK MODE</span>
          <Toggle selected={theme === 'dark'} setSelected={toggleTheme} />
        </div>
        <div className="settings-row">
          <span className="settings-text">GAME SOUND</span>
          <Toggle selected={soundEnabled} setSelected={toggleSound} />
        </div>
        <div className="settings-row">
          <span className="settings-text flex gap-2">
            <span>SUPPORT</span>
          </span>
          <span className="settings-link">
            <a href="mailto:support@playletterswap.com?subject=LetterSwap%20Support">Email</a>
          </span>
        </div>
        <div className="settings-row">
          <span className="settings-text">USERNAME</span>
          <TextField value={username} onChange={setUsername} placeholder="Enter name" alignRight />
        </div>
      </div>
    </Dialog>
  );
}

export default SettingsDialog;
